import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_PRICING_DETAILS_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/75555523444/details/23424234755/pricing-and-rewards
 */

export class TripPricingDetailsController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trip.Pricing,U,80';
  /**
   * Note that the tripViewId path param is optional since travelers can access the pricing and
   * rewards page for a cancelled booking that does not have an associated trip.
   */
  public readonly path = `${BASEPATH}/trips/:tripViewId([a-z0-z-]+)?/details/:tripItemId([a-z0-z-]+)/pricing-and-rewards`;
  public readonly routeName = 'trip-pricing-details';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-pricing-details" */ 'views/trip-pricing-details-view')
  );
  public readonly pageName = 'page.Trip.Pricing';
  public readonly clickstreamPageName = 'Trip Pricing';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_PRICING_DETAILS_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trip-pricing-details-controller'
    });

    return Promise.resolve();
  }
}
